<template>
  <div class="kk-page-home">
    <nav class="kk-page-home__nav">
      <ul class="kk-page-home__nav--items">
        <li class="item">
          <router-link to="/">
            <img data-test-id="'kyra-logo'" :src="require('@/assets/kyra-logo.svg')" alt="Kyra Logo" />
          </router-link>
        </li>
        <li class="item">
          <language color="#92a3ab" />
        </li>
        <li class="item">
          <a
            data-test-id="'contact-link'"
            href="https://www.kern.ag/de/kontakt/kontaktanfrage"
            class="kk-btn kk-btn__contact"
          >
            {{ $t("homePage.contact") }}
          </a>
        </li>
        <li class="item">
          <router-link
            v-if="authState == 'signed-in'"
            data-test-id="'process-design-button'"
            to="/designs"
            class="kk-btn kk-btn__designs-btn"
          >
            <span>{{ $t("homePage.processDesigns") }}</span>
          </router-link>
          <router-link v-else to="/signin" class="kk-btn kk-btn__login-btn">
            <span>{{ $t("homePage.signIn") }}</span>
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="kk-page-home__content">
      <div class="kk-page-home__content--text">
        <h1 data-test-id="'homepage-title-text'" class="kk-page-home__content--text-title">
          {{ $t("homePage.header.part1") }} <br /><span>{{ $t("homePage.header.part2") }}</span>
        </h1>
        <slider :message="$tm('homePage.message')" />
        <button data-test-id="'test-for-free-button'">
          <router-link v-if="authState == 'signed-in'" to="/designs" class="kk-btn kk-btn__designs-btn">
            <span>{{ $t("homePage.tryBtn") }}</span>
          </router-link>
          <router-link v-else to="/signin" class="kk-btn kk-btn__login-btn">
            <span>{{ $t("homePage.tryBtn") }}</span>
          </router-link>
        </button>
      </div>
      <div class="kk-page-home__content--image">
        <img :src="require('@/assets/image.svg')" alt="Relay Sprint Image" />
      </div>
    </div>
    <footer class="kk-page-home__footer">
      <ul class="kk-page-home__footer--items">
        <li class="item">
          <a href="https://www.kern.ag/de" class="kk-link"> Kern AG </a>
        </li>
        <li class="item">
          <router-link to="/impressum" class="kk-link"> {{ $t("homePage.disclosure") }} </router-link>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
import Language from "../components/navbar/Language.vue";
import Slider from "../components/commons/Slider.vue";
export default {
  components: { Language, Slider },
  computed: {
    authState() {
      return this.$store.state.authState;
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables";

.kk-page-home {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  // height: calc(100vh + 2rem);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  background-image: url("../assets/bg.svg");
  background-size: contain;
  background-position: right;
  padding: 0 8rem;

  &__nav {
    padding-top: 1rem;
    &--items {
      list-style-type: none;
      display: flex;
      align-items: center;
      gap: 0.4rem;
      .item {
        &:first-child {
          flex-grow: 1;
        }
        img {
          width: 10rem;
          margin-left: -1.4rem;
        }
        .kk-btn {
          padding: 0.4rem 1.5rem;
          border-radius: @kk-border-radius;
          text-decoration: none;
          font-weight: 600;
          color: #92a3ab;
          transition: all 0.3s;
          &__contact {
            margin-right: 0.5rem;
            &:hover {
              outline: 1px solid @kk-color-primary-blue;
              box-shadow: @kk-color-primary-blue 0px 10px 15px -10px;
            }
          }
          &__login-btn,
          &__designs-btn {
            background: #d76fff;
            color: white;
            &:hover {
              box-shadow: @kk-color-primary-blue 0px 10px 15px -10px;
            }
          }
        }
      }
    }
  }

  &__content {
    width: 100%;
    display: flex;
    &--text,
    &--image {
      flex-basis: 50%;
    }
    &--text {
      button {
        padding: 0.4rem 1.5rem;
        border-radius: @kk-border-radius;
        background: #d76fff;
        margin-top: 3rem;
        transition: all 0.3s;
        &:hover {
          box-shadow: @kk-color-primary-blue 0px 10px 15px -10px;
        }
        .kk-btn {
          text-decoration: none;
          color: white;
          font-weight: 600;
        }
      }
      &-title {
        font-size: 3.5rem;
        line-height: 3.4rem;
        color: #d76fff;
        span {
          color: @kk-color-primary-blue;
        }
      }
    }
    &--image {
      text-align: right;
      img {
        width: 35rem;
      }
    }
  }

  &__footer {
    width: 100vw;
    margin-left: -8rem;
    padding: 1rem 8rem;
    background-color: @kk-color-primary-blue;
    color: white;
    &--items {
      list-style-type: none;
      margin-left: -1.4rem;
      .item {
        &:first-child {
          font-weight: 600;
        }
        .kk-link {
          text-decoration: none;
          color: white;
        }
      }
    }
  }
}
@media only screen and (max-width: 600px) {
  .kk-page-home {
    width: 100vw;
    height: 100vh;
    padding: 0 2rem;
    background-size: cover;
    &__content {
      flex-direction: column;
      &--text,
      &--image {
        flex-basis: 100%;
      }
      &--text {
        button {
          margin-top: 1.5rem;
        }
        &-title {
          font-size: 2.5rem;
          line-height: 2.4rem;
          margin-top: 4rem;
        }
      }
      &--image {
        text-align: right;
        img {
          width: 20rem;
          margin-top: 2rem;
        }
      }
    }
    &__footer {
      width: calc(100vw + 7rem);
      margin-left: -2rem;
      padding: 2rem 2rem;
    }
  }
}

@media only screen and (max-width: 900px) {
  .kk-page-home {
    width: 100vw;
    height: 100vh;
    padding: 0 4rem;
    background-size: cover;
    &__content {
      &--text {
        &-title {
          font-size: 2.5rem;
          line-height: 2.4rem;
        }
      }
      &--image {
        img {
          width: 25rem;
        }
      }
    }
    &__footer {
      margin-left: -4rem;
      padding: 1rem 4rem;
    }
  }
}
</style>
